import React from "react";
import { Link } from "react-router-dom";
import NewsletterSignup from "@/components/NewsletterSignup";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-edge bg-linen mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-serif text-3xl">Folio</div>
          <p className="text-muted_ink mt-3 max-w-sm text-sm leading-relaxed">
            A small, slow press for books worth re-reading. Digital editions, beautifully made.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="label-eyebrow mb-4">Catalog</div>
          <ul className="space-y-2 text-sm text-muted_ink">
            <li>Literary Fiction</li>
            <li>Essays</li>
            <li>Poetry</li>
            <li>Short Stories</li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="label-eyebrow mb-4">Letters from the press</div>
          <NewsletterSignup variant="footer" />
          <Link
            to="/subscribe"
            data-testid="footer-subscribe-link"
            className="text-xs uppercase tracking-widest text-muted_ink hover:text-terracotta mt-4 inline-block"
          >
            Or learn more →
          </Link>
        </div>
      </div>
      <div className="border-t border-edge">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted_ink">
          <div>© {new Date().getFullYear()} Folio Press. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link
              to="/privacy"
              data-testid="footer-privacy-link"
              className="uppercase tracking-widest hover:text-terracotta transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/cookies"
              data-testid="footer-cookies-link"
              className="uppercase tracking-widest hover:text-terracotta transition-colors"
            >
              Cookies
            </Link>
            <button
              type="button"
              data-testid="cookie-preferences-link"
              onClick={() => {
                // Secure Privacy exposes a couple of API surfaces depending on version.
                // Try each; fall back to the manual global helper we defined in index.html.
                if (typeof window.SPShowCookieBanner === "function") window.SPShowCookieBanner();
                else if (window.SecurePrivacy && typeof window.SecurePrivacy.showBanner === "function") window.SecurePrivacy.showBanner();
                else if (typeof window.allConsentDenied === "function") {
                  window.allConsentDenied();
                  // Nudge the page so the banner re-appears on next load
                  try {
                    localStorage.removeItem("SP_CONSENT_STATUS");
                    localStorage.removeItem("folio_consent");
                  } catch (err) {
                    console.warn("[footer] could not clear consent keys:", err);
                  }
                  window.location.reload();
                }
              }}
              className="uppercase tracking-widest hover:text-terracotta transition-colors"
            >
              Cookie preferences
            </button>
            <div className="uppercase tracking-widest">Made for readers, slowly.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
